import { render, staticRenderFns } from "./JirkaTeplota.vue?vue&type=template&id=96e9bfbe&scoped=true&"
import script from "./JirkaTeplota.vue?vue&type=script&lang=js&"
export * from "./JirkaTeplota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e9bfbe",
  null
  
)

export default component.exports